import { render, staticRenderFns } from "./CollaboratorTable.vue?vue&type=template&id=dca86418&"
import script from "./CollaboratorTable.vue?vue&type=script&lang=js&"
export * from "./CollaboratorTable.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports